/* eslint-disable jsx-a11y/alt-text */
import {
  IconoRodado,
  IconoInmueble,
  IconoComercio,
  IconoCementerio,
  IconoCuotasPagar,
  IconoRecibo,
} from "../shared/iconos";
import TipoImp from "../shared/TipoImp";
import "./main.scss";

const Main = () => {
  return (
    <div className="container">
      <h2 className="titulo text-center">Seleccione el Tributo</h2>
      <div className="row mt-5">
        <div className="col flex-row text-center">
          <TipoImp
            name={"Inmuebles"}
            url={"/apps/inmueble/inmuebles"}
            icono={[<IconoInmueble />]}
          />
          {/* <TipoImp name={'Recupero Plan Federal'} url={'/apps/inmueble/recupero-plan-federal'} />
                    <TipoImp name={'Residuos Patógenos'} url={'/apps/inmueble/cementerio'} />
                    <TipoImp name={'Natatorios '} url={'/apps/inmueble/natatorio'} /> */}
        </div>
      </div>
    </div>
  );
};

export default Main;
